import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n.use(HttpBackend).use(LanguageDetector).use(initReactI18next).init({
    fallbackLng: 'zh-TW',
    supportedLngs: ['zh-TW'],
    load: 'currentOnly',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language',
      convertDetectedLanguage: (lng) => {
        // 將 zh、zh-CN、zh-Hans 等都轉換為 zh-TW
        if (lng.startsWith('zh')) {
          return 'zh-TW';
        }
        return lng;
      }
    }
  });
export default i18n;
